import {Skeleton} from '@sollapay/ui/components';
import {createPortal} from 'react-dom';

import {usePermissions} from '@/features/authentication';
import {TRUST_ACCOUNT_WRITE_PERMISSIONS} from '@/features/trust-accounts/utils';

import type {FC} from 'react';

export const QuickActionsFabSkeleton: FC = () => {
  const {hasPermission} = usePermissions(); // account not loaded yet, so use role-level check
  if (!TRUST_ACCOUNT_WRITE_PERMISSIONS.some(hasPermission)) return null;

  return createPortal(
    // portaled to dodge PageLayout's <main> animate-in, which would jump the fixed position
    <div className="pointer-events-none fixed bottom-20 end-6 z-40">
      <Skeleton className="h-14 w-14 rounded-full" />
    </div>,
    document.body
  );
};
